import axios from "@/hooks/axios/axios";
import { buildQueryParams } from "@/lib/buildQueryParams";
import type { KeywordPostQueryParams } from "../types/keyword.types";

export const fetchPosts = async (params: KeywordPostQueryParams) => {
  const {
    "x-api-token": apiToken,
    include_keywords,
    additional_keywords,
    exclude_keywords,
    limit = 10,
    page = 1,
    platforms,
    countries,
    languages,
    influencer_id,
    is_verified,
    date_range,
  } = params;

  const base: Record<string, string | undefined> = {
    limit: String(limit),
    page: String(page),
    countries: countries?.length ? countries.join(",") : undefined,
    languages: languages?.length ? languages.join(",") : undefined,
    influencer_id: influencer_id || undefined,
    is_verified:
      typeof is_verified === "boolean" ? String(is_verified) : undefined,
    last_24_hours: date_range === "last_24_hours" ? "true" : undefined,
    last_seven_days: date_range === "last_seven_days" ? "true" : undefined,
    last_thirty_days: date_range === "last_thirty_days" ? "true" : undefined,
  };

  const queryString = buildQueryParams(base, {
    platforms,
    include_keywords,
    additional_keywords,
    exclude_keywords,
  });

  const { data } = await axios.get(`/es/posts?${queryString}`, {
    headers: { "x-api-token": apiToken },
  });
  return data;
};
